var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgIconReasoning(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    preserveAspectRatio: "none",
    overflow: "visible",
    style: {
      display: "block"
    },
    width: 23,
    height: 30,
    viewBox: "0 0 23 30",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Container"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Icon",
    d: "M11.5 30C10.6567 30 9.93472 29.7063 9.33417 29.1188C8.73361 28.5313 8.43333 27.825 8.43333 27H14.5667C14.5667 27.825 14.2664 28.5313 13.6658 29.1188C13.0653 29.7063 12.3433 30 11.5 30ZM5.36667 25.5V22.5H17.6333V25.5H5.36667ZM5.75 21C3.98667 19.975 2.5875 18.6 1.5525 16.875C0.5175 15.15 0 13.275 0 11.25C0 8.125 1.11806 5.46875 3.35417 3.28125C5.59028 1.09375 8.30556 0 11.5 0C14.6944 0 17.4097 1.09375 19.6458 3.28125C21.8819 5.46875 23 8.125 23 11.25C23 13.275 22.4825 15.15 21.4475 16.875C20.4125 18.6 19.0133 19.975 17.25 21H5.75Z",
    fill: "#924700"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconReasoning);
export default __webpack_public_path__ + "static/media/icon-reasoning.6815978d3d0abecc340ce42f7e21ca9b.svg";
export { ForwardRef as ReactComponent };